import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "knowledge-test",
  "aria-labelledby": "knowledge-title"
}
const _hoisted_2 = { class: "knowledge-test__header" }
const _hoisted_3 = { class: "knowledge-test__eyebrow" }
const _hoisted_4 = { id: "knowledge-title" }
const _hoisted_5 = ["aria-busy"]
const _hoisted_6 = { class: "knowledge-test__intro" }
const _hoisted_7 = { class: "knowledge-test__identity" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("em", null, "*", -1)
const _hoisted_9 = ["value", "placeholder"]
const _hoisted_10 = ["value", "placeholder"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "knowledge-test__missing",
  role: "alert"
}
const _hoisted_13 = { class: "knowledge-test__questions" }
const _hoisted_14 = {
  key: 1,
  class: "knowledge-test__notice",
  role: "alert"
}
const _hoisted_15 = {
  key: 2,
  class: "knowledge-test__notice",
  role: "status",
  "aria-live": "polite"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsMarketTestSkeleton = _resolveComponent("SettingsMarketTestSkeleton")!
  const _component_SettingsMarketTestState = _resolveComponent("SettingsMarketTestState")!
  const _component_SettingsMarketTestQuestion = _resolveComponent("SettingsMarketTestQuestion")!
  const _component_SettingsMarketTestRisks = _resolveComponent("SettingsMarketTestRisks")!
  const _component_SettingsMarketTestFooter = _resolveComponent("SettingsMarketTestFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("Тест уровня знаний рынка")), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("Тест уровня знаний и компетентности клиента")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Для совершения операций с виртуальными активами")), 1)
    ]),
    _createVNode(_Transition, {
      name: "knowledge-content",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.isVerified && !_ctx.visibleResult && _ctx.identityLoading)
          ? (_openBlock(), _createBlock(_component_SettingsMarketTestSkeleton, { key: "loading" }))
          : (_ctx.stateView)
            ? (_openBlock(), _createBlock(_component_SettingsMarketTestState, _mergeProps({
                key: _ctx.stateView.props.title
              }, _ctx.stateView.props, {
                role: _ctx.stateView.role,
                "aria-live": _ctx.stateView.live,
                onAction: _ctx.handleStateAction
              }), null, 16, ["role", "aria-live", "onAction"]))
            : (_openBlock(), _createElementBlock("form", {
                key: "form",
                class: "knowledge-test__form",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
                "aria-busy": _ctx.submissionState === 'submitting'
              }, [
                _createElementVNode("aside", _hoisted_6, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t("Порядок оценки результатов")), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.assessmentRules)), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", null, [
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("Ф.И.О. / наименование клиента")), 1),
                      _hoisted_8
                    ]),
                    _createElementVNode("input", {
                      value: _ctx.client.name,
                      placeholder: _ctx.$t('Данные отсутствуют'),
                      readonly: ""
                    }, null, 8, _hoisted_9)
                  ]),
                  _createElementVNode("label", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Для юридического лица: Ф.И.О. ЕИО (представителя)")), 1),
                    _createElementVNode("input", {
                      value: _ctx.client.representative,
                      placeholder: _ctx.client.legal ? _ctx.$t('Данные отсутствуют') : '—',
                      readonly: ""
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("label", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Дата заполнения")), 1),
                    _createElementVNode("input", {
                      class: "knowledge-test__date",
                      value: _ctx.filledDate,
                      readonly: ""
                    }, null, 8, _hoisted_11)
                  ])
                ]),
                (!_ctx.client.complete)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t(
              _ctx.client.legal
                ? "В подтверждённой анкете отсутствуют обязательные данные клиента или представителя. Для уточнения данных обратитесь в поддержку."
                : "В подтверждённой анкете отсутствуют обязательные данные клиента. Для уточнения данных обратитесь в поддержку."
            )), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
                    return (_openBlock(), _createBlock(_component_SettingsMarketTestQuestion, {
                      key: index,
                      modelValue: _ctx.selections[index],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.selections[index]) = $event),
                      question: question,
                      index: index,
                      disabled: _ctx.submissionState === 'submitting'
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "question", "index", "disabled"]))
                  }), 128))
                ]),
                _createVNode(_component_SettingsMarketTestRisks, {
                  modelValue: _ctx.risksAcknowledged,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.risksAcknowledged) = $event)),
                  risks: _ctx.risks,
                  disabled: _ctx.submissionState === 'submitting'
                }, null, 8, ["modelValue", "risks", "disabled"]),
                (_ctx.submissionState === 'error')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.submissionError ||
            _ctx.$t("Не удалось отправить ответы. Попробуйте ещё раз.")), 1))
                  : (_ctx.submissionNotice)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t(_ctx.submissionNotice)), 1))
                    : _createCommentVNode("", true),
                _createVNode(_component_SettingsMarketTestFooter, {
                  answered: _ctx.answeredCount,
                  total: _ctx.questions.length,
                  message: _ctx.progressMessage,
                  disabled: !_ctx.canSubmit,
                  submitting: _ctx.submissionState === 'submitting'
                }, null, 8, ["answered", "total", "message", "disabled", "submitting"])
              ], 40, _hoisted_5))
      ]),
      _: 1
    })
  ]))
}